
import { useEffect, useState } from "react";

import { Tabla } from "../../../components/Table/Table";
// import { useUser } from "../../../hooks/useUser";
import LoadingModal from "../../../components/LoadingModal/LoadingModal";

import { ArrowLeft, Eye } from "react-feather";
import { useSelector } from "react-redux";
import TituloModal from "./Components/TituloModal";
import { useHistory } from "react-router-dom";
import { actuacionesService } from "../../../_services/actuaciones.service";
import { useUser } from "../../../hooks/useUser";

const Titulos = () => {
  const { imponibles } = useSelector(e => e.dashboard);
  const user = useUser();
  const history = useHistory();

  const [dataList, setDataList] = useState([]);
  const [showLoading, setShowLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [titulos, setTitulos] = useState([]);

  useEffect(() => {
    getData();
  }, [imponibles]);

  const getData = async () => {
    setShowLoading(true);
    
    const res = await actuacionesService.listaTitEjecutivos({
      abogado: user.abogado,
    });

    setTitulos(res?.titulos);
    setDataList(imponibles?.imponibles);
    
    setShowLoading(false);
  };

  const handleShow = (e) => {
    setData(e);
    setShow(true);
  };

  const handleClose = () => {
    setData("");
    setShow(false);
  };

  const handleBack = () => {
    history.push("/mesa-judicial");
  };
  // APYNOM
  // CALLE
  // IMPONIBLE
  // NRO
  // NRO_DOC
  // RECURSO
  const columns = [
    {
      title: "CONTRIBUYENTE",
      dataIndex: "APYNOM",
    },
    {
      title: "IMPONIBLE",
      dataIndex: "IMPONIBLE",
    },
    {
      title: "TITULO",
      dataIndex: "titulo",
      render: (a, row) => {
        return (
          <div className="d-flex">
            <Eye
              className="mx-2 action-table"
              onClick={() => handleShow(row)}
            />
          </div>
        );
      },
    },
    {
      title: "RECURSO",
      dataIndex: "RECURSO",
    },
    {
      title: "PERIODO DESDE",
      dataIndex: "",
    },
    {
      title: "PERIODO HASTA",
      dataIndex: "",
    },
    {
      title: "FECHA DE EMISIÓN",
      dataIndex: "",
    },
  ];

  const formatData = (arrayData) => {
    try {
      if (!arrayData?.length || !Array.isArray(arrayData)) return [];

      let res = arrayData.map((item) => {
        return item;
      });

      return res;
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  return (
    <div className="section-content">
      <div className="mb-3 fw-600" style={{ textAlign: "start" }}>TITULOS</div>
      <div className="w-100 d-flex justify-content-start mb-3">
        <ArrowLeft onClick={handleBack} className="cursor-pointer" />
      </div>
      <div className="data-content">
        <div className="data-table p-3">
          <Tabla
            dataList={formatData(dataList)}
            columns={columns}
          />          
        </div>
      </div>

      {show && <TituloModal show={show} handleClose={handleClose} titulos={titulos} data={data} />}
      {showLoading && <LoadingModal show={showLoading} loading={true} />}
    </div>
  );
};


export default Titulos;